import {
  DocumentListCard,
  Field,
  YesObject
} from '@yes.technology/react-toolkit'
import RelationClass from '../RelationClass/RelationClass'
import { RelationConfigProps, RelationFieldType } from '../types/object-view'
import useRelationClasses from './useRelationClasses/useRelationClasses'

type RelationClassesProps = {
  defaultFieldType: RelationFieldType
  relationFields: Field[]
  fieldValues: YesObject | undefined
  relationConfig?: RelationConfigProps
  informational?: boolean
  isEditing?: boolean
  edit: () => void
  onChange: (fieldColumn: string, value: YesObject[string]) => void
  save: (fieldToSave: string) => Promise<void>
  changeAndSave: (
    fieldColumn: string,
    value: YesObject[string]
  ) => Promise<void>
}

const RelationClasses = ({
  defaultFieldType,
  relationFields,
  fieldValues,
  relationConfig,
  informational,
  isEditing,
  edit,
  onChange,
  save,
  changeAndSave
}: RelationClassesProps) => {
  const relationClasses = useRelationClasses({ relationFields, relationConfig })

  return (
    <div className='row row-gap-4'>
      {relationClasses.map((relationField: Field, index) => {
        return (
          <div
            key={`${relationField.relation_objectclass_uuid}-${index}`}
            className={`${relationConfig?.[relationField.uuid]?.column || 'col-lg-6'}`}
          >
            <DocumentListCard className='h-100 p-0'>
              <RelationClass
                fieldType={
                  relationConfig?.[relationField.uuid]?.field_type ||
                  defaultFieldType
                }
                relationFieldRelation={relationField.relation}
                hierarchyLevel={
                  relationConfig?.[relationField.uuid]?.hierarchy_level ||
                  'level_3'
                }
                actionButton={
                  relationConfig?.[relationField.uuid]?.action_button
                }
                layoutClassificationUuid={
                  relationConfig?.[relationField.uuid]
                    ?.uuid_layout_classification
                }
                field={relationField}
                informational={informational}
                navigationSliderBackgroundColor={
                  relationConfig?.[relationField.uuid]
                    ?.navigationslider_background_color || '#DDE5ED'
                }
                navigationSliderColor={
                  relationConfig?.[relationField.uuid]
                    ?.navigationslider_color || '#303032'
                }
                fieldSettings={
                  relationConfig?.[relationField.uuid]?.field_settings
                }
                hideInsertAction={
                  relationConfig?.[relationField.uuid]?.table_actions_visibility
                    ?.insert === false
                }
                hideSelectAndLinkAction={
                  relationConfig?.[relationField.uuid]?.table_actions_visibility
                    ?.select_and_link === false
                }
                hideDocumentUploadAction={
                  relationConfig?.[relationField.uuid]?.table_actions_visibility
                    ?.document_upload === false
                }
                selectAndLinkTargetPath={
                  relationConfig?.[relationField.uuid]
                    ?.select_and_link_target_path
                }
                uploadAcceptedFileTypes={
                  relationConfig?.[relationField.uuid]
                    ?.upload_accepted_file_types
                }
                {...{
                  edit,
                  isEditing,
                  onChange,
                  save,
                  changeAndSave,
                  fieldValues
                }}
              />
            </DocumentListCard>
          </div>
        )
      })}
    </div>
  )
}

export default RelationClasses
